import { AfterViewInit, Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { Actions, Store } from '@ngxs/store';
import { CertificationProviderStatusEnum } from 'app/library/certification-provider/enums/certification-provider-status.enum';
import { CertificationProvider } from 'app/library/certification-provider/models/certification-provider';
import { CertificationProviderStatus } from 'app/library/certification-provider/models/certification-provider-status.model';
import { CertificationProviderDataSource } from 'app/main/pages/certifications/certifications-all/datasource';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-providers-list-dialog',
    templateUrl: './providers-list-dialog.component.html',
    styleUrls: ['./providers-list-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ProvidersListDialogComponent extends UnsubscribeOnDestroy implements OnInit, AfterViewInit {
    @Input()
    filteredCertificationProviders$: Observable<CertificationProvider[]>;

    @Input()
    certificationProvidersTotalCount$: Observable<number>;

    @Input()
    providerToDisable: CertificationProvider;

    isLoading: boolean = false;
    selectedProvider: CertificationProvider;

    certificationProviderStatus = CertificationProviderStatus;
    CertificationProviderStatusEnum = CertificationProviderStatusEnum;

    @ViewChild(MatPaginator)
    paginator: MatPaginator;

    displayedColumns: string[] = ['provider', 'status', 'buttons'];
    dataSource: CertificationProviderDataSource;

    constructor(private _store: Store, public dialogRef: MatDialogRef<ProvidersListDialogComponent>, private _action$: Actions) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.dataSource = new CertificationProviderDataSource(
            this.filteredCertificationProviders$.pipe(map((providers) => providers.filter((provider) => provider.id !== this.providerToDisable.id))),
            this._store,
            this._action$
        );
    }

    ngAfterViewInit() {
        this.paginator.page.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            this.loadCertificationProvidersPage(false);
        });

        // Always load once view is ready so data appears even when stored pageSize equals the template default
        // (persistPageSize only emits a page event when the restored size differs).
        this.loadCertificationProvidersPage(false);
    }

    removeFromList(provider: CertificationProvider): void {
        this.selectedProvider = null;

        this.dataSource = new CertificationProviderDataSource(
            this.filteredCertificationProviders$.pipe(
                map((providers) => {
                    providers = providers.filter((provider) => provider.id !== this.providerToDisable.id);

                    return providers.map((item) => {
                        if (item.id === provider.id) {
                            item = Object.assign(new CertificationProvider(), item, {
                                selected: false,
                            });
                        }
                        return item;
                    });
                })
            ),
            this._store,
            this._action$
        );
    }

    addToList(provider: CertificationProvider): void {
        this.selectedProvider = provider;

        this.dataSource = new CertificationProviderDataSource(
            this.filteredCertificationProviders$.pipe(
                map((providers) => {
                    providers = providers.filter((provider) => provider.id !== this.providerToDisable.id);

                    return providers.map((item) => {
                        if (item.id === this.selectedProvider.id) {
                            item = Object.assign(new CertificationProvider(), item, {
                                selected: true,
                            });
                        }
                        return item;
                    });
                })
            ),
            this._store,
            this._action$
        );
    }

    saveSelected(): void {
        this.dialogRef.close(this.selectedProvider);
    }

    async loadCertificationProvidersPage(resetPageIndex = false): Promise<void> {
        this.isLoading = true;

        if (resetPageIndex) {
            this.paginator.pageIndex = 0;
        }

        this.dataSource.loadCertificationProviders(this.paginator?.pageSize, this.paginator?.pageIndex + 1, '', [0], []);

        setTimeout(() => {
            this.isLoading = false;
        });
    }
}
